import { render, staticRenderFns } from "./VideoComponentFs.vue?vue&type=template&id=3818caf7&scoped=true"
import script from "./VideoComponentFs.vue?vue&type=script&lang=js"
export * from "./VideoComponentFs.vue?vue&type=script&lang=js"
import style0 from "./VideoComponentFs.vue?vue&type=style&index=0&id=3818caf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3818caf7",
  null
  
)

export default component.exports